import { FiFilter } from "react-icons/fi";
import { Button } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { useSelector } from "react-redux";
import {
  isButtonProcessing,
  getButtonProcessingClass,
} from "../../utils/common-utils";

const ButtonFilter = (props) => {
  const buttonProcessingState = useSelector((state) => state.button_processing);
  const isProcessing = isButtonProcessing(buttonProcessingState, props);
  const processingClass = getButtonProcessingClass(isProcessing);
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "primary",
    className: `rounded-[6px] min-w-[140px] lg:h-10 h-[38px] ${props.className} ${processingClass}`,
    isProcessing,
  };
  const text = props.text ? props.text : "絞り込み";
  return (
    <Button {...tmpProps}>
      <FiFilter className="mr-[4px] lg:h-5 lg:w-5 h-[18px] w-[18px]" />
      {text}
    </Button>
  );
};

export default ButtonFilter;
